import { DeleteOutlined } from "@ant-design/icons";
import { Button } from "antd";
export const RemoveDetailBtn = ({ icon, showText = false, ...others }) => {
  return (
    <Button
      color="danger"
      variant="outlined"
      {...others}
      icon={!icon ? <DeleteOutlined /> : icon}
    >
      {showText && "Eliminar"}
    </Button>
  );
};
